<template>
  <div>
    <el-button-group v-if="!isViewDisabled">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="add()"
        class="mb-2"
        >{{ $l('form_add_btn') || '新增' }}</el-button
      >
    </el-button-group>
    <!-- 表格-->
    <el-table
      :data="tableData"
      stripe
      size="small"
      :height="height"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="appraisalByName"
        :label="$l('appraise_table_label_evaluator') || '评价人'"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="appraisalScore"
        :label="$l('appraise_table_label_score') || '综合评分'"
        min-width="180"
      >
        <template slot-scope="scope">
          <el-row
            v-for="(item, index) in scope.row.ratingList"
            :key="index"
            style="margin-top: 5px"
          >
            <div style="display: inline-flex;justify-content: flex-start">
              <span
                >{{ item.ratingItemName }}({{ item.ratingItemNameEn }})：{{
                  item.rating
                }}</span
              >
            </div>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="appraisalDescription"
        :label="$l('appraise_table_label_comments') || '评价意见'"
        min-width="300"
      >
        <template slot-scope="scope">
          <span
            style="white-space: pre-wrap;word-break:normal;word-wrap:break-word;"
          >
            {{ scope.row.appraisalDescription }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="appraisalDate"
        :label="$l('appraise_table_label_evaluation_time') || '评价时间'"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        :label="$l('table_label_operation') || '操作'"
        min-width="200"
        align="center"
        v-if="!isViewDisabled"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit-outline"
            @click="update(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <template>
      <el-pagination
        background
        :current-page="params.curPage"
        :page-size="params.pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, sizes, prev, pager, next, jumper, ->, slot"
      >
      </el-pagination>
    </template>

    <el-dialog
      @opened="dialogOpened"
      @closed="dialogClosed"
      :title="dialogTitle"
      :visible.sync="dialogVisible1"
      width="600px"
    >
      <AppraisalDetail
        ref="appraisalDetail"
        @back="back"
        @getData="getData"
      ></AppraisalDetail>
    </el-dialog>
  </div>
</template>
<script>
import AppraisalDetail from './detail/appraisalDetail'

export default {
  props: {
    height: {
      default: 450,
      type: Number
    }
  },
  components: {
    AppraisalDetail
  },
  data() {
    return {
      value1: 3,
      dialogVisible1: false,
      isViewDisabled: false,
      dialogTitle: '',
      tableData: [],
      formData: {
        appraisalCode: '',
        scmCode: '',
        appraisalDate: '',
        appraisalBy: '',
        appraisalByName: '',
        appraisalDescription: '',
        ratingList: []
      },
      params: {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      },
      total: 0
    }
  },
  methods: {
    init(scmCode, isViewDisabled) {
      this.params.scmCode = scmCode
      this.isViewDisabled = isViewDisabled
      this.getData()
    },
    reset() {
      this.dialogVisible1 = false
      this.isViewDisabled = false
      this.tableData = []
      this.formData = {}
      this.params = {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      }
      this.getData()
    },
    getData() {
      this.$api.scmInfoAppraisalListApi(this.params).then((res) => {
        this.total = res.body.count
        this.params.curPage = res.body.curPage
        this.params.pageSize = res.body.pageSize
        this.tableData = res.body.data
        this.tableData.ratingList = res.body.data.ratingList
      })
    },
    dialogOpened() {
      this.$refs.appraisalDetail.init(this.formData)
    },
    dialogClosed() {
      this.getData()
    },
    add() {
      this.formData = {
        type: 'add',
        scmCode: this.params.scmCode
      }
      this.dialogTitle = '厂商评价新增'
      this.dialogVisible1 = true
    },
    update(row) {
      this.dialogTitle = '厂商评价修改'
      this.formData = row
      this.formData.type = 'edit'
      this.dialogVisible1 = true
    },
    delRow(row) {
      this.$confirm('是否删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData = {
          appraisalCode: row.appraisalCode
        }
        this.$api.scmInfoAppraisalSaveApi(this.formData).then(() => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        })
      })
    },
    back() {
      this.dialogVisible1 = false
    },
    sizeChange(val) {
      this.params.curPage = 1
      this.params.pageSize = val
      this.getData()
    },
    currentChange(val) {
      this.params.curPage = val
      this.getData()
    }
  }
}
</script>
